import { IBannerListItem, News } from '@/interface'

const state = {
  newsList: [] as News[],
  newsDetail: {} as News,
  total: 0,
  banner: null as IBannerListItem | null
}

export type NewsState = typeof state

const newsStore = {
  namespaced: true,
  state,
  mutations: {
    setNewsList (state: NewsState, news: News[]) {
      state.newsList = news
    },
    setNewsDetail (state: NewsState, newsDetail: News) {
      state.newsDetail = newsDetail
    },
    setNewsTotal (state: NewsState, total: number) {
      state.total = total
    },
    setBannerInfo (state: NewsState, banner: IBannerListItem | null) {
      state.banner = banner
    }
  }
}

export { newsStore }
